import * as actionTypes from "./actionTypes";

/**
 * Sets an entire dictionary to store.benefits
 */
export const setBenefits = (value) => {
  return {
    type: actionTypes.SET_BENEFITS,
    value,
  };
};

/**
 * Appends/updates key-value pair in store.benefits
 * obj {key: value}
 */
export const setBenefitsAttr = (obj) => {
  return {
    type: actionTypes.SET_BENEFITS_ATTR,
    obj,
  };
};

export const clearBenefits = () => {
  return {
    type: actionTypes.CLEAR_BENEFITS,
  };
};
